import { ReactNode } from 'react';
import { ReviewerSelectionProvider } from './ReviewerSelectionContext';
import { ReviewerInviteListProvider } from './ReviewerInviteListProvider';

export const ReviewersProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ReviewerSelectionProvider>
      <ReviewerInviteListProvider>{children}</ReviewerInviteListProvider>
    </ReviewerSelectionProvider>
  );
};
